import Vue from 'vue'
import map from './vue/mapa.vue'

window.axios = require('axios');
window.Vue = Vue

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

Vue.component('map-component', map);



// WEBPACK FOOTER //
// ./scripts/vuecomponents.js